import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'src/environments/environment';
import Swal from 'sweetalert2';
import { Marcas } from '../_model/marcas';
import { Media } from '../_model/media';
import { Produtos, ProdutosSend } from '../_model/produtos';
import { Tipo } from '../_model/tipo';
import { MarcasService } from '../_services/marcas.service';
import { ProdutosService } from '../_services/produtos.service';
import { faPencilAlt, faTrash } from '@fortawesome/free-solid-svg-icons';

@Component({
    selector: 'app-insertProduct',
    templateUrl: './insertProduct.component.html',
    styleUrls: ['./insertProduct.component.less'],
    standalone: false
})
export class InsertProductComponent implements OnInit {

  faPencilAlt = faPencilAlt;
  faTrash = faTrash;

  constructor(private prod: ProdutosService, private marca: MarcasService, private route: ActivatedRoute) {}

  produtos: Produtos[] = [];

  marcas: Marcas[] = [];

  printMarcas: Marcas[] = [];

  model: ProdutosSend = new ProdutosSend();

  marcaSel: Marcas = new Marcas();

  cat: string = "";

  links: any[] = [];

  tipo: Tipo[] = [

    new Tipo({
      key: "alta",
      name: "Alta Relojoaria"
    }),
    new Tipo({
      key: "relogio",
      name: "Relojoaria"
    }),
    new Tipo({
      key: "j1",
      name: "Joalharia"
    }),
    new Tipo({
      key: "j2",
      name: "Pratas"
    }),
    new Tipo({
      key: "acess",
      name: "Acessórios"
    }),
    new Tipo({
      key: 'noiva',
      name: 'Noivas'
    })
  ];

  selTipo: Tipo[] = [];

  disableMarcas = true;

  apiUrl: string = environment.apiUrl;

  ngOnInit() {
    this.marca.list().subscribe((data: any[]) => {
      data.forEach(el => {
        this.marcas.push(new Marcas(el));
        this.printMarcas.push(new Marcas(el));
      });
      this.prod.list().subscribe((data: any) => {
        data.forEach(el => {
          this.produtos.push(new Produtos(el));
        });
        this.route.queryParams.subscribe(params => {
          var id = Number.parseInt(params['id']);
          if(id) {
            this.bind(this.produtos.filter(x => x.id == id)[0]);
            this.links = [{link: 'admin', name: 'Administração'},{link: 'admin/gestao', name: 'Gestão de Produtos'}];
          }else{
            this.links = [{link: 'admin', name: 'Administração'}];
          }
        });
      });
    });
    this.model.userId = localStorage.getItem("userId");
    
  }


  getMarca(item: Produtos) {
    if(item?.marcasId && this.marcas?.length){
      return this.printMarcas.filter(x => x.id == item.marcasId)[0].nome;
    }
    return "";
  }

  changeType(event) {
    if(event.includes('Tipo')) {
      this.marcas = this.printMarcas;
      if(this.selTipo.length != 0) {
        this.selTipo.forEach(el => {
          this.marcas = this.marcas.filter(x => x.tipo.includes(el.key));
        });
        this.disableMarcas = false;
      }else{
        this.disableMarcas = true;
      }
    }
  }
  
  send() {
    this.model.marcasId = this.marcaSel.id;
    this.model.tipo = "";
    this.selTipo.forEach(it => {
      this.model.tipo += it.key+";";
    });
    if(this.model.nome == '') {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta o nome do produto</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.tipo == ''){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Faltam os tipos do produto</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.marcasId == -1){
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta a marca do produto</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.ref == '') {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Falta referência do produto</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else if(this.model.media.length == 0) {
      Swal.fire({
        title: "<h1 class='textColor harvest-gold base'>Faltam imagens do produto</h1>",
        icon: 'warning',
        customClass: {
          popup: 'card-border-gold',
        }
      });
    }else {
      this.prod.send(this.model).subscribe(() => {
        this.prod.list().subscribe((data: any) => {
          this.produtos = [];
          data.forEach(el => {
            this.produtos.push(new Produtos(el));
          });
        });
        if(this.model.id > 0) {
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Produto actualizado com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }else{
          Swal.fire({
            title: "<h1 class='textColor harvest-gold base'>Produto inserido com sucesso</h1>",
            icon: 'success',
            position: "top-end",
            timer: 1500,
            showConfirmButton: false,
            customClass: {
              popup: 'card-border-gold',
            }
          });
        }
        this.clear();
      });
    }
  }

  bind(item: Produtos) {
    this.model.id = item.id;
    this.model.nome = item.nome;
    this.model.tipo = item.tipo;
    this.model.desc = item.desc;
    this.model.activo = item.activo;
    this.model.colecao = item.colecao;
    this.model.marcasId = item.marcasId;
    this.model.preco = item.preco;
    this.model.carecteristicas = item.carecteristicas;
    this.model.ref = item.ref;
    this.model.userId = localStorage.getItem("userId");
    this.selTipo = [];
    var t = item.tipo.split(";").filter(x => x != '');
    t.forEach(it => {
      this.selTipo.push(new Tipo(this.tipo.filter(x => x.key.includes(it))[0]))
    });
    this.marcaSel = new Marcas(this.marcas.filter(x => x.id == item.marcasId)[0]);
    this.prod.getRawMedia(item.id).subscribe((data: any) => {
      this.model.media= [];
      data.forEach(el => {
        this.model.media.push(new Media(el));
      });
    });
  }

  clear() {
    this.model = new ProdutosSend();
    this.model.userId = localStorage.getItem("userId");
    this.marcaSel = new Marcas();
    this.selTipo = [];
  }

  delete(item: Produtos) {
    Swal.fire({
      title: "Tem a certeza que pretende eliminar o produto?",
      text: "Se continuar com esta ação ira eliminar "+item.nome+" da base de dados",
      icon: 'warning',
      confirmButtonText: 'Eliminar',
      cancelButtonText: 'Cancelar',
      showCancelButton: true,
      customClass: {
        confirmButton: "btn red base",
        cancelButton: "btn green base"
      }
    }).then((result) => {
      if(result.isConfirmed) {
        Swal.fire({
          title: "Produto Eliminado com sucesso",
          text: "O produto "+item.nome+" foi eliminado da base de dados",
          icon: 'success'
        });
        this.prod.delete(item.id, localStorage.getItem("userId")).subscribe(() => {
          this.clear();
          
          this.prod.list().subscribe((data: any) => {
            this.produtos = [];
            data.forEach(el => {
              this.produtos.push(new Produtos(el));
            });
          });
        });
      }
    });
  }

}
